.overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	padding: 1rem;
}

.modal {
	background: #fff;
	border-radius: 0.75rem;
	width: 100%;
	max-width: 800px;
	max-height: 90vh;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	box-shadow:
		0 20px 25px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	border-bottom: 1px solid #e5e7eb;
}

.errorContainer {
	padding: 1rem 1.5rem 0;
}

.title {
	margin: 0;
	font-size: 1.25rem;
	font-weight: 600;
	color: #111827;
}

.closeButton {
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	color: #6b7280;
	cursor: pointer;
	padding: 0.25rem;
	border-radius: 0.375rem;
	transition: all 0.2s ease;

	&:hover {
		background: #f3f4f6;
		color: #111827;
	}
}

.container {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	padding: 1.5rem;
	overflow-y: auto;
}

.summary {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
	gap: 1rem;
}

.summaryCard {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	padding: 1rem;
	background: #f9fafb;
	border-radius: 0.5rem;
	border: 1px solid #e5e7eb;
}

.summaryLabel {
	font-size: 0.75rem;
	font-weight: 500;
	color: #6b7280;
	text-transform: uppercase;
	letter-spacing: 0.025em;
}

.summaryValue {
	font-size: 1.5rem;
	font-weight: 700;
	color: #111827;
}

.summaryPercentage {
	font-size: 0.875rem;
	font-weight: 600;
	margin-top: 0.25rem;
}

.completed {
	background: rgba(127, 176, 47, 0.05);
	border-color: rgba(127, 176, 47, 0.2);

	.summaryPercentage {
		color: #7fb02f;
	}
}

.inProgress {
	background: rgba(59, 130, 246, 0.05);
	border-color: rgba(59, 130, 246, 0.2);

	.summaryPercentage {
		color: #3b82f6;
	}
}

.pending {
	background: rgba(107, 114, 128, 0.05);
	border-color: rgba(107, 114, 128, 0.2);
}

.programs {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}

.programsTitle {
	margin: 0;
	font-size: 0.875rem;
	font-weight: 600;
	color: #111827;
	text-transform: uppercase;
	letter-spacing: 0.025em;
}

.program {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 0.75rem;
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
}

.programHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
}

.programName {
	font-weight: 600;
	color: #111827;
	font-size: 0.875rem;
}

.programActions {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-shrink: 0;
}

.programStats {
	display: flex;
	align-items: center;
	gap: 0.75rem;
}

.deleteButton {
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	color: #ef4444;
	cursor: pointer;
	padding: 0.375rem;
	border-radius: 0.375rem;
	transition: all 0.2s ease;

	&:hover {
		background: rgba(239, 68, 68, 0.1);
		color: #dc2626;
	}
}

.statCompleted {
	font-weight: 600;
	color: #7fb02f;
	font-size: 0.875rem;
}

.statInProgress {
	font-weight: 600;
	color: #3b82f6;
	font-size: 0.875rem;
}

.programDetails {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
	gap: 0.5rem;
	font-size: 0.75rem;
	color: #6b7280;
}

.detail {
	strong {
		color: #111827;
		font-weight: 600;
	}
}

.progressBar {
	display: flex;
	width: 100%;
	height: 6px;
	background: #e5e7eb;
	border-radius: 9999px;
	overflow: hidden;
}

.progressCompleted {
	height: 100%;
	background: linear-gradient(to right, #7fb02f, #8bc234);
	transition: width 0.3s ease;
}

.progressInProgress {
	height: 100%;
	background: linear-gradient(to right, #3b82f6, #60a5fa);
	transition: width 0.3s ease;
}

.noData {
	padding: 2rem;
	text-align: center;
	color: #6b7280;
	font-size: 0.875rem;
	background: #f9fafb;
	border-radius: 0.5rem;
	border: 1px dashed #d1d5db;
}

@media (max-width: 640px) {
	.summary {
		grid-template-columns: repeat(2, 1fr);
	}

	.programDetails {
		grid-template-columns: repeat(2, 1fr);
	}
}
